/** Icon codes written in square brackets inside tag text, e.g. "[star] Most popular". */
export const GIFT_PASS_TAG_ICONS = [
  'star',
  'heart',
  'flame',
  'sparkles',
  'gift',
  'leaf',
  'tree',
  'clock',
  'ticket',
  'check',
] as const;
export type GiftPassTagIcon = (typeof GIFT_PASS_TAG_ICONS)[number];

export type GiftPassTagTextPart =
  | { kind: 'text'; text: string }
  | { kind: 'icon'; icon: GiftPassTagIcon };

const ICON_CODE = /\[([a-z]+)\]/g;

export function isGiftPassTagIcon(code: string): code is GiftPassTagIcon {
  return (GIFT_PASS_TAG_ICONS as readonly string[]).includes(code);
}

/** A bracketed code that is not on the list stays as literal text. */
export function parseGiftPassTagText(text: string): GiftPassTagTextPart[] {
  const parts: GiftPassTagTextPart[] = [];
  let last = 0;
  for (const match of text.matchAll(ICON_CODE)) {
    const code = match[1];
    if (!isGiftPassTagIcon(code)) continue;
    if (match.index > last) parts.push({ kind: 'text', text: text.slice(last, match.index) });
    parts.push({ kind: 'icon', icon: code });
    last = match.index + match[0].length;
  }
  if (last < text.length) parts.push({ kind: 'text', text: text.slice(last) });
  return parts;
}
